export type DateLike = Date | string | number | null | undefined;

function toDate(d: DateLike): Date | null {
  if (d == null) return null;
  if (d instanceof Date) return isNaN(d.getTime()) ? null : d;
  const dt = new Date(d as any);
  return isNaN(dt.getTime()) ? null : dt;
}

export function formatTimeHM(d: DateLike): string {
  const dt = toDate(d);
  if (!dt) return '';
  return dt.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
}

export function formatDateDMY(d: DateLike): string {
  const dt = toDate(d);
  if (!dt) return '';
  const day = String(dt.getDate()).padStart(2, '0');
  const month = String(dt.getMonth() + 1).padStart(2, '0');
  const year = String(dt.getFullYear());
  return `${day}-${month}-${year}`;
}

export function formatDateTimeDMYHM(d: DateLike): string {
  const dt = toDate(d);
  if (!dt) return '';
  const date = formatDateDMY(dt);
  const time = formatTimeHM(dt);
  if (!date) return time;
  if (!time) return date;
  return `${date} ${time}`;
}

const ISO_DATE_TIME_RE = /\b\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{1,3})?(?:Z|[+-]\d{2}:\d{2})\b/g;

export function humanizeIsoInText(text: string): string {
  if (!text) return text;
  if (!ISO_DATE_TIME_RE.test(text)) return text;
  return text.replace(ISO_DATE_TIME_RE, (m) => {
    const dt = toDate(m);
    if (!dt) return m;
    return formatDateTimeDMYHM(dt);
  });
}
